import cn from "classnames";
import { ReactNode } from "react";

export type BiuTabItem = {
    title: string | ReactNode;
    content: ReactNode;
};

type BiuTabsProps = {
    tabs: BiuTabItem[];
    activeTab: number;
    onTabChange: (index: number) => void;
};

export const BiuTabs: React.FC<BiuTabsProps> = ({ tabs, activeTab, onTabChange }) => {
    const innerShadow = { boxShadow: "inset 0px -4px 4px -4px rgba(0, 0, 0, .1)" };

    return (
        <div className="w-full">
            <div className="flex">
                {tabs.map((tab, i) => (
                    <div
                        key={i}
                        style={i === activeTab ? {} : innerShadow}
                        className={cn("border-r border-separators-page py-2 px-6 cursor-pointer select-none transition-colors", {
                            "border-b bg-background-top-nav-tabs text-muted-body-text hover:text-body-text": i !== activeTab,
                            "bg-white font-semibold text-brand-primary": i === activeTab,
                        })}
                        onClick={() => onTabChange(i)}
                    >
                        {tab.title}
                    </div>
                ))}
                <div style={innerShadow} className="border-b flex-grow border-separators-page bg-background-top-nav-tabs" />
            </div>
            <div className="p-3 border border-t-0 border-separators-page">{tabs[activeTab]?.content}</div>
        </div>
    );
};
